import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'styles-sheet-page',
  templateUrl: './styles-sheet-page.component.html',
  styleUrls: ['./styles-sheet-page.component.scss']
})
export class StylesSheetPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
